/**
 * Application constants
 */

// Firebase configuration
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDYoVrSR4CeN66OI80XcXlwQMUSiw5CvH8",
  authDomain: "mr-oscars.firebaseapp.com",
  projectId: "mr-oscars",
  storageBucket: "mr-oscars.firebasestorage.app",
  messagingSenderId: "209373935334",
  appId: "1:209373935334:web:36515b050569d478e6ad27",
  measurementId: "G-3CF5D30TL1"
};

// Oscars Party IDs
// Note: The active party ID is now controlled by BetaContext based on URL path
// - V1 (default routes): uses OSCARS_PARTY_ID_2026
// - V2 (beta routes /beta/*): uses OSCARS_PARTY_ID_2025
export const OSCARS_PARTY_ID_2025 = "oscars_party_2025";
export const OSCARS_PARTY_ID_2026 = "oscars_party_2026";

// @deprecated - Use useBeta().activePartyId from BetaContext instead
export const ACTIVE_OSCARS_PARTY_ID = OSCARS_PARTY_ID_2026;

// Lightweight client-side leaderboard gate code (low-security by design)
export const LEADERBOARD_ACCESS_CODE = 'youmustbepresent2026';

// Martin-Resnick Oscar Party 2026 invite details
export const OSCAR_INVITE_2026 = {
  headline: '"Will it be a Sinner Supreme Battle or a Focused Hamnet!!"',
  partyTitle: 'The Official Martin-Resnick Party',
  academyAwards: '98th ANNUAL ACADEMY AWARDS',
  tagline: '"You Must Be Present To Win!!"',
  venue: {
    name: 'The Martin-Resnick HD Cinema Network',
    address: '8012 Berger Place',
    city: 'Playa del Rey, CA',
    phone: '310-968-5542 / 310-968-4377',
  },
  pregameTime: '2:30 PM',
  mainEventTime: '4:00 PM',
  social: {
    cta: 'Follow us for daily updates!!',
    instagram: '@MROscarParty',
  },
  whatToBring: 'Your Official Oscar Ballot, plus $10',
  ballotDeadlineNote: 'Ballots must be submitted by Sunday, March 15th, 2026 at 4:00 PM to be official!',
  emailNote: '(EMAIL is OK – bruce_resnick@parkerresnick.com)',
};
